module.exports = __webpack_public_path__ + "img/com.moji.MojiWeatherNew.dd0d39f7.png";